import { render, staticRenderFns } from "./BlockLayout.vue?vue&type=template&id=c8f41324&"
import script from "./BlockLayout.vue?vue&type=script&lang=js&"
export * from "./BlockLayout.vue?vue&type=script&lang=js&"
import style0 from "./BlockLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports